export default __webpack_public_path__ + "0fb2d5295f8b611c3a6a7372039fce9c.jpg";